import {ValidatorUtil} from '@aperza/validator';

export default class FormFieldUtil {

  static findFormFieldByFieldName(formFields, fieldName) {
    if (Array.isArray(formFields)) {
      return formFields.find(formField => formField.fieldName === fieldName);
    }
    return undefined;
  }

  static validateFieldByFieldName(formFields, fieldName, value) {
    let fields = formFields.slice();
    let field = FormFieldUtil.findFormFieldByFieldName(fields, fieldName);
    if (field) {
      let errorId = FormFieldUtil.validateField(field, value);
      if (errorId) {
        field.errorId = errorId;
        field.invalid = true;
        field.value = value;
      } else {
        field.errorId = undefined;
        field.invalid = false;
        field.value = value;
      }
    }
    return fields;
  }

  static validateField(formField, value) {
    if (formField.constraint) {
      return ValidatorUtil.validateValue(value, formField.constraint);
    }
    return undefined;
  }

  static validateFields(formFields) {
    if (Array.isArray(formFields)) {
      let updatedFields = formFields.map(formField => {
        let errorId = FormFieldUtil.validateField(formField, formField.value);
        let clonedField = Object.assign({}, formField);
        if (errorId) {
          clonedField.errorId = errorId;
          clonedField.invalid = true;
        } else {
          clonedField.errorId = undefined;
          clonedField.invalid = false;
        }
        return clonedField;
      });
      return updatedFields;
    }
    return undefined;
  }

  static convertFieldsToMap(formFields) {
    let map = {};
    if (Array.isArray(formFields)) {
      formFields.forEach(formField => {
        map[formField.fieldName] = formField;
      });
    }
    return map;
  }

  static getValueMap(formFields) {
    let map = {};
    if (Array.isArray(formFields)) {
      formFields.forEach(formField => {
        map[formField.fieldName] = formField.value;
      });
    }
    return map;
  }

  static reset(formFields) {
    let map = {};
    if (Array.isArray(formFields)) {
      formFields.forEach(formField => {
        formField.value = '';
      });
    }
    return map;
  }


  static isValid(formFields) {
    return !FormFieldUtil.hasError(formFields);
  }

  static hasError(formFields = []) {
    let errorCount = 0;
    formFields.forEach(formField => {
      if (formField.errorId) {
        errorCount = errorCount + 1;
      }
    });
    return errorCount > 0;
  }


}
